const C = 'screen.parties.parties.action.create';
export const PARTIES_EN = {
    // A refusal the person may overrule, and the record it names.
    'action.checkFirst': 'Check before saving',
    'action.saveAnyway': 'Save anyway',
    'action.openRecord': 'Open {name}',
    'parties.duplicate.shared': '{value} is already held by {name}. A branch shares its company’s number: save anyway if this is one.',
    'parties.duplicate.own': '{value} is already held by {name}. A person’s own number names one person: open that party instead of adding a second.',
    // Find or create (POST /parties/find-or-create) and its review: each refusal under the field it names.
    'parties.refusal.match.nothing': 'Give at least one number to match on: mobile, email, commercial registration, VAT number or ID number.',
    'parties.refusal.match.mobile': 'A mobile is digits with its country code, or a local number as dialled (05…).',
    'parties.refusal.match.email': 'An email is an address such as name@example.sa.',
    'parties.refusal.match.cr': 'A commercial registration is 10 digits, and an organisation holds it.',
    'parties.refusal.match.vat': 'A VAT number is 15 digits starting and ending with 3, and an organisation holds it.',
    'parties.refusal.match.id_number': 'The ID number does not have its document’s shape, or it is not a person’s.',
    'parties.refusal.match.id_type': 'Say which document the number is: national ID, iqama or passport.',
    'parties.refusal.match.kind': 'Say whether this is a person or an organisation.',
    'parties.refusal.match.display_name': 'A name is needed to add the party when nobody matches.',
    'parties.refusal.match.roles': 'Roles are customer and/or vendor.',
    'parties.refusal.match.source': 'The reference needs both the caller’s name and its own key.',
    'parties.refusal.match.permission': 'Adding a party needs the permission to create and change parties.',
    'parties.refusal.match.consents_permission': 'Recording the consents a form carried needs the permission to manage consents.',
    'parties.refusal.match.consents_look': 'A lookup records nothing: send the consents only with a request that may add or link the party.',
    'parties.refusal.match.decision': 'Choose the party this is, or say it is somebody new.',
    'parties.refusal.match.decided': 'This match was decided already.',
    'parties.refusal.match.no_party': 'That party is not on the register.',
    'parties.refusal.match.inactive': 'That party is archived; choose an active one.',
    [`${C}.label`]: 'New party',
    [`${C}.field.display_name.help`]: 'As it is printed on an invoice — in Arabic when the invoice is in Arabic.',
    [`${C}.field.name_en`]: 'Name in English',
    [`${C}.field.roles`]: 'Offered as',
    [`${C}.field.roles.help`]: 'Which pickers offer it: an invoice offers customers, a bill vendors.',
    [`${C}.field.vat`]: 'VAT number',
    [`${C}.field.vat.help`]: '15 digits, starting and ending with 3.',
    [`${C}.field.cr`]: 'Commercial registration',
    [`${C}.field.id_type`]: 'Identity document',
    [`${C}.field.id_number`]: 'Document number',
    [`${C}.field.id_number.help`]: 'National ID: 10 digits starting with 1; iqama: starting with 2.',
    [`${C}.field.id_expires_on`]: 'Expires on',
    [`${C}.field.nationality`]: 'Nationality',
    [`${C}.field.birth_date`]: 'Date of birth',
    [`${C}.field.gender`]: 'Gender',
    [`${C}.field.address_building_number`]: 'Building number',
    [`${C}.field.address_street`]: 'Street',
    [`${C}.field.address_district`]: 'District',
    [`${C}.field.address_city`]: 'City',
    [`${C}.field.address_postcode`]: 'Postcode',
    [`${C}.field.address_additional_number`]: 'Additional number',
    [`${C}.field.address_short_address`]: 'Short address',
    [`${C}.field.address_short_address.help`]: 'Four letters then four digits, such as RNAD4521.',
    [`${C}.field.phone`]: 'Mobile',
    [`${C}.field.email`]: 'Email',
    [`${C}.field.contact_name`]: 'Contact person',
    [`${C}.field.contact_name.help`]: 'Made a person on the register and named on the party’s page. More are added from the party.',
    [`${C}.field.contact_phone`]: 'Contact’s mobile',
    [`${C}.field.contact_email`]: 'Contact’s email',
    [`${C}.section.party`]: 'The party',
    [`${C}.section.registration`]: 'Registration',
    [`${C}.section.registration.help`]: 'The numbers ZATCA and a buyer’s invoice need. Another party holding the same number is named before saving.',
    [`${C}.section.identity`]: 'Identity',
    [`${C}.section.address`]: 'National address',
    [`${C}.section.address.help`]: 'As registered with the national address service. Leave it empty to add it later.',
    [`${C}.section.reach`]: 'How to reach it',
    'screen.parties.parties.action.edit.field.name_en': 'Name in English',
    'screen.parties.parties.action.edit.field.email': 'Email',
    'screen.parties.parties.action.edit.field.roles': 'Offered as',
    'screen.parties.parties.action.add_contact.label': 'Add contact person',
    'screen.parties.parties.action.add_contact.field.name': 'Name',
    'screen.parties.parties.action.add_contact.field.phone': 'Mobile',
    'screen.parties.parties.action.add_contact.field.email': 'Email',
    'screen.parties.parties.action.add_identifier.field.scheme.option.passport': 'Passport',
    'screen.parties.parties.action.add_identifier.field.expires_on': 'Expires on',
    'screen.parties.parties.column.roles': 'Offered as',
    'parties.role.customer': 'Customer',
    'parties.role.vendor': 'Vendor',
    'parties.gender.male': 'Male',
    'parties.gender.female': 'Female',
    'parties.party.col.name_en': 'Name in English',
    'parties.party.col.email': 'Email',
    'parties.party.col.birth_date': 'Date of birth',
    'parties.party.col.gender': 'Gender',
    'parties.party.col.contact_email': 'Contact’s email',
    'parties.party.card.contact': 'Contact',
    'parties.party.card.born': 'Date of birth and gender',
    'parties.party.card.born.empty': 'No date of birth or gender is registered for this person.',
    'parties.party.scheme.passport': 'Passport',
    'parties.party.card.contact.empty': 'No email or contact person is registered for this party yet.',
    // The change record's words for what the form now keeps.
    'change.field.party.name_en': 'Name in English',
    'change.field.party.email': 'Email',
    'change.field.party.roles': 'Offered as',
    'change.field.party.birth_date': 'Date of birth',
    'change.field.party.gender': 'Gender',
    'change.field.party.expires_on': 'Expires on',
    'change.field.party.note': 'Note',
    'change.field.party.retired_by': 'Ended by',
};
export const PARTIES_AR = {
    'action.checkFirst': 'راجِع قبل الحفظ',
    'action.saveAnyway': 'احفظ على أي حال',
    'action.openRecord': 'افتح {name}',
    'parties.duplicate.shared': 'الرقم {value} مسجّل لـ{name}. الفرع يحمل رقم منشأته: احفظ على أي حال إن كان هذا فرعًا.',
    'parties.duplicate.own': 'الرقم {value} مسجّل لـ{name}. رقم الشخص يدلّ على شخص واحد: افتح ذلك الطرف بدل إضافة طرف ثانٍ.',
    'parties.refusal.match.nothing': 'أدخل رقمًا واحدًا على الأقل للمطابقة: الجوال أو البريد أو السجل التجاري أو الرقم الضريبي أو رقم الهوية.',
    'parties.refusal.match.mobile': 'الجوال أرقام مع رمز الدولة، أو رقم محلي كما يُطلب (05…).',
    'parties.refusal.match.email': 'البريد عنوان مثل name@example.sa.',
    'parties.refusal.match.cr': 'السجل التجاري عشرة أرقام، وتحمله منشأة.',
    'parties.refusal.match.vat': 'الرقم الضريبي 15 رقمًا يبدأ بـ3 وينتهي بـ3، وتحمله منشأة.',
    'parties.refusal.match.id_number': 'رقم الهوية ليس على شكل وثيقته، أو ليس رقم شخص.',
    'parties.refusal.match.id_type': 'حدّد نوع الوثيقة: هوية وطنية أو إقامة أو جواز سفر.',
    'parties.refusal.match.kind': 'حدّد إن كان شخصًا أو منشأة.',
    'parties.refusal.match.display_name': 'الاسم مطلوب لإضافة الطرف حين لا يطابقه أحد.',
    'parties.refusal.match.roles': 'الأدوار: عميل و/أو مورّد.',
    'parties.refusal.match.source': 'المرجع يحتاج اسم الجهة الطالبة ومفتاحها معًا.',
    'parties.refusal.match.permission': 'إضافة طرف تحتاج صلاحية إنشاء الأطراف وتعديلها.',
    'parties.refusal.match.consents_permission': 'تسجيل الموافقات التي حملها النموذج يحتاج صلاحية إدارة الموافقات.',
    'parties.refusal.match.consents_look': 'البحث وحده لا يسجّل شيئاً: أرسل الموافقات فقط مع طلب يضيف الطرف أو يربطه.',
    'parties.refusal.match.decision': 'اختر الطرف المقصود، أو قرّر أنه طرف جديد.',
    'parties.refusal.match.decided': 'حُسمت هذه المطابقة من قبل.',
    'parties.refusal.match.no_party': 'هذا الطرف غير موجود في السجل.',
    'parties.refusal.match.inactive': 'هذا الطرف مؤرشف؛ اختر طرفًا نشطًا.',
    [`${C}.label`]: 'طرف جديد',
    [`${C}.field.display_name.help`]: 'كما يُطبع على الفاتورة — بالعربية حين تكون الفاتورة بالعربية.',
    [`${C}.field.name_en`]: 'الاسم بالإنجليزية',
    [`${C}.field.roles`]: 'يُعرض بصفته',
    [`${C}.field.roles.help`]: 'أيّ القوائم تعرضه: الفاتورة تعرض العملاء، وفاتورة المورّد تعرض المورّدين.',
    [`${C}.field.vat`]: 'الرقم الضريبي',
    [`${C}.field.vat.help`]: '15 رقمًا تبدأ بـ3 وتنتهي بـ3.',
    [`${C}.field.cr`]: 'السجل التجاري',
    [`${C}.field.id_type`]: 'وثيقة الهوية',
    [`${C}.field.id_number`]: 'رقم الوثيقة',
    [`${C}.field.id_number.help`]: 'الهوية الوطنية: 10 أرقام تبدأ بـ1، والإقامة: تبدأ بـ2.',
    [`${C}.field.id_expires_on`]: 'تنتهي في',
    [`${C}.field.nationality`]: 'الجنسية',
    [`${C}.field.birth_date`]: 'تاريخ الميلاد',
    [`${C}.field.gender`]: 'الجنس',
    [`${C}.field.address_building_number`]: 'رقم المبنى',
    [`${C}.field.address_street`]: 'الشارع',
    [`${C}.field.address_district`]: 'الحي',
    [`${C}.field.address_city`]: 'المدينة',
    [`${C}.field.address_postcode`]: 'الرمز البريدي',
    [`${C}.field.address_additional_number`]: 'الرقم الإضافي',
    [`${C}.field.address_short_address`]: 'العنوان المختصر',
    [`${C}.field.address_short_address.help`]: 'أربعة أحرف ثم أربعة أرقام، مثل RNAD4521.',
    [`${C}.field.phone`]: 'الجوال',
    [`${C}.field.email`]: 'البريد الإلكتروني',
    [`${C}.field.contact_name`]: 'الشخص المسؤول',
    [`${C}.field.contact_name.help`]: 'يُسجَّل شخصًا في السجل ويُذكر في صفحة الطرف. يُضاف غيره من صفحة الطرف.',
    [`${C}.field.contact_phone`]: 'جوال المسؤول',
    [`${C}.field.contact_email`]: 'بريد المسؤول',
    [`${C}.section.party`]: 'الطرف',
    [`${C}.section.registration`]: 'التسجيل',
    [`${C}.section.registration.help`]: 'الأرقام التي تحتاجها هيئة الزكاة والضريبة وفاتورة المشتري. إن كان الرقم مسجّلًا لطرف آخر يُسمّى قبل الحفظ.',
    [`${C}.section.identity`]: 'الهوية',
    [`${C}.section.address`]: 'العنوان الوطني',
    [`${C}.section.address.help`]: 'كما هو مسجّل في خدمة العنوان الوطني. اتركه فارغًا لإضافته لاحقًا.',
    [`${C}.section.reach`]: 'التواصل',
    'screen.parties.parties.action.edit.field.name_en': 'الاسم بالإنجليزية',
    'screen.parties.parties.action.edit.field.email': 'البريد الإلكتروني',
    'screen.parties.parties.action.edit.field.roles': 'يُعرض بصفته',
    'screen.parties.parties.action.add_contact.label': 'إضافة شخص مسؤول',
    'screen.parties.parties.action.add_contact.field.name': 'الاسم',
    'screen.parties.parties.action.add_contact.field.phone': 'الجوال',
    'screen.parties.parties.action.add_contact.field.email': 'البريد الإلكتروني',
    'screen.parties.parties.action.add_identifier.field.scheme.option.passport': 'جواز السفر',
    'screen.parties.parties.action.add_identifier.field.expires_on': 'تنتهي في',
    'screen.parties.parties.column.roles': 'يُعرض بصفته',
    'parties.role.customer': 'عميل',
    'parties.role.vendor': 'مورّد',
    'parties.gender.male': 'ذكر',
    'parties.gender.female': 'أنثى',
    'parties.party.col.name_en': 'الاسم بالإنجليزية',
    'parties.party.col.email': 'البريد الإلكتروني',
    'parties.party.col.birth_date': 'تاريخ الميلاد',
    'parties.party.col.gender': 'الجنس',
    'parties.party.col.contact_email': 'بريد المسؤول',
    'parties.party.card.contact': 'التواصل',
    'parties.party.card.born': 'الميلاد والجنس',
    'parties.party.card.born.empty': 'لا تاريخ ميلاد ولا جنس مسجّل لهذا الشخص.',
    'parties.party.scheme.passport': 'جواز السفر',
    'parties.party.card.contact.empty': 'لا بريد ولا شخص مسؤول مسجّل لهذا الطرف بعد.',
    'change.field.party.name_en': 'الاسم بالإنجليزية',
    'change.field.party.email': 'البريد الإلكتروني',
    'change.field.party.roles': 'يُعرض بصفته',
    'change.field.party.birth_date': 'تاريخ الميلاد',
    'change.field.party.gender': 'الجنس',
    'change.field.party.expires_on': 'تنتهي في',
    'change.field.party.note': 'ملاحظة',
    'change.field.party.retired_by': 'أنهاها',
};
//# sourceMappingURL=i18n-parties.js.map